/**
 * @file The master (parent) Purchase Album view.
 */

import React from 'react';
import PropTypes from 'prop-types';
import { useLocation } from 'react-router-dom';
import { renderRoutes } from 'react-router-config';

import PurchaseAlbumLayoutContainer from '../../containers/purchase/PurchaseAlbumLayoutContainer';
import { sentryCaptureMessage } from '../../util/sentry';

const propTypes = {
  route: PropTypes.object,
};

const PurchaseAlbumMasterView = ({ route }) => {
  const location = useLocation();

  // This is to determine usage of these views and subsequently delete them if really
  // unused or handle redirections if they are used and delete their components.
  sentryCaptureMessage('[PurchaseAlbumMasterView Visited]', {
    level: 'error',
    extra: {
      error: 'PurchaseAlbumMasterView',
      location,
    },
  });

  return (
    <PurchaseAlbumLayoutContainer>
      {renderRoutes(route.routes)}
    </PurchaseAlbumLayoutContainer>
  );
};

PurchaseAlbumMasterView.propTypes = propTypes;

export default PurchaseAlbumMasterView;
